import React from 'react'
import './footer.css'


function Footer() {
    return (
        <div className="footer">
            <h1>Buy a cycle and ride it for pleasure</h1>
            <p>to know details plese visit the our explore section</p>

        </div>
    )
}

export default Footer
